import {RequestFulfillment, RequestFulfillmentDefinition} from './FulfillmentConstants';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const fulfillmentMatchesDefinition = (
  fulfillment: RequestFulfillment,
  fulfillmentDefinition: RequestFulfillmentDefinition
) =>
  fulfillment.requestId === fulfillmentDefinition.requestId &&
  fulfillment.sampleGroupId === fulfillmentDefinition.sampleGroupId &&
  fulfillment.requestTaskId === fulfillmentDefinition.requestTaskId;
